import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const VendorInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Get vendor id from logged in user
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const vendorId = user.id;

  useEffect(() => {
    if (user.user_type !== 3) {
      navigate('/unauthorized');
      return;
    }
    if (!vendorId) return;
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/vendorinvoices?vendor_id=${vendorId}`)
      .then(res => res.json())
      .then(data => {
        setInvoices(data.invoices || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [vendorId, user.user_type, navigate]);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Coaching Invoices</h2>
      {loading ? (
        <div style={styles.loading}>Loading invoices...</div>
      ) : invoices.length === 0 ? (
        <div style={styles.empty}>No invoices found.</div>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Invoice #</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map(inv => (
              <tr key={inv.id}>
                <td style={styles.td}>{inv.id}</td>
                <td style={styles.td}>${inv.amount}</td>
                <td style={styles.td}>
                  <span style={{
                    color: inv.status === 'paid' ? '#388e3c' : '#d32f2f',
                    fontWeight: 'bold'
                  }}>
                    {inv.status}
                  </span>
                </td>
                <td style={styles.td}>
                  {inv.date ? new Date(inv.date).toLocaleDateString() : ''}
                </td>
                <td style={styles.td}>
                  <button
                    style={styles.detailsBtn}
                    onClick={() => navigate(`/invoicedetails/${inv.id}`)}
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  loading: {
    textAlign: 'center',
    color: '#4078c0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginTop: '40px',
    letterSpacing: '1px',
  },
  empty: {
    textAlign: 'center',
    color: '#888',
    fontSize: '1.1rem',
    marginTop: '32px',
    fontStyle: 'italic',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '18px',
    fontSize: '1.05rem',
  },
  th: {
    background: '#f5f6fa',
    color: '#8d6e36',
    fontWeight: 'bold',
    fontSize: '1.08rem',
    padding: '12px 8px',
    borderBottom: '2px solid #e0cfa0',
    textAlign: 'left',
  },
  td: {
    padding: '10px 8px',
    borderBottom: '1px solid #e0cfa0',
    fontSize: '1.05rem',
    textAlign: 'left',
    verticalAlign: 'top',
  },
  detailsBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '6px 16px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    marginLeft: '8px',
  },
};

export default VendorInvoices;
